import React from 'react';
import { Hero } from './components/SalesPage/Hero';
import { OpeningLead } from './components/SalesPage/OpeningLead';
import { ProblemSection } from './components/SalesPage/ProblemSection';
import { RealProblemSection } from './components/SalesPage/RealProblemSection';
import { MechanismReveal } from './components/SalesPage/MechanismReveal';
import { UniqueMechanism } from './components/SalesPage/UniqueMechanism';
import { ObjectionHandler } from './components/SalesPage/ObjectionHandler';
import { WhatIncludes } from './components/SalesPage/WhatIncludes';
import { ContentPreview } from './components/SalesPage/ContentPreview';
import { MidPageCTA } from './components/SalesPage/MidPageCTA';
import { ForWhom } from './components/SalesPage/ForWhom';
import { QuickWins } from './components/SalesPage/QuickWins';
import { TrustBadge } from './components/SalesPage/TrustBadge';
import { FAQ } from './components/SalesPage/FAQ';
import { PricingCTA } from './components/SalesPage/PricingCTA';
import { FinalClose } from './components/SalesPage/FinalClose';
import { FloatingCTA } from './components/SalesPage/FloatingCTA';
import { Footer } from './components/SalesPage/Footer';
export function App() {
  return <main className="min-h-screen w-full bg-[#faf7f2] overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />
      <OpeningLead data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <RealProblemSection data-id="element-4" />
      <MechanismReveal data-id="element-5" />
      <UniqueMechanism data-id="element-6" />
      <ObjectionHandler data-id="element-7" />
      <WhatIncludes data-id="element-8" />
      <ContentPreview data-id="element-9" />
      <MidPageCTA data-id="element-10" />
      <ForWhom data-id="element-11" />
      <QuickWins data-id="element-12" />
      <TrustBadge data-id="element-13" />
      <FAQ data-id="element-14" />
      <PricingCTA data-id="element-15" />
      <FinalClose data-id="element-16" />
      <Footer data-id="element-17" />
      <FloatingCTA data-id="element-18" />
    </main>;
}